import { makeAnonEdgeHttpClient, makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseVerifyOtpRepository } from '@/modules/auth/infra'
import type { VerifyOtp } from '@/modules/auth/use-cases'
import { makeOtpFlowMemory } from './make-otp-flow-memory'

export function makeVerifyOtp(): VerifyOtp {
  return new SupabaseVerifyOtpRepository(
    makeSupabaseClient(),
    makeAnonEdgeHttpClient(),
    makeSupabaseEdgeHttpClient(),
    makeOtpFlowMemory(),
  ).execute
}
